var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{bpanel2:_vm.mode>0} ,{bpanel:_vm.mode==0}]},[_c('div',{class:[{chartnamepanel2:_vm.mode>0} ,{chartnamepanel:_vm.mode==0}]},[_c('p',[_vm._v(" "+_vm._s(_vm.chartname))])]),_c('div',{class:[{echart2:_vm.mode>0} ,{echart:_vm.mode==0}],attrs:{"id":'container222' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }